<div class="admin-modal admin-job-console-edit">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise = !minimise"></i>
      <i class="fa fa-times" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    <form #jobForm="ngForm" novalidate>

      @if (loading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
}

      @if (!loading) {


        <!-- Row 1: Job ID + Job Type (both disabled) -->
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Job Id:</label>
            <input type="text" class="form-control" name="JOB_ID"
                   [(ngModel)]="jobConsoleParams.JOB_ID" disabled />
          </div>
          <div class="col-md-6">
            <label>Job Type:</label>
            <select class="form-control" name="JOB_TYPE"
                    [(ngModel)]="jobConsoleParams.JOB_TYPE" disabled>
              @for (j of jobTypeList; track $index) {
<option [ngValue]="j">{{ j }}</option>
}
            </select>
          </div>
        </div>

        <!-- Row 2: Domain Type + Job Name (Job Name disabled) -->
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Domain Type:</label>
            <select class="form-control" name="DOMAIN_TYPE"
                    [(ngModel)]="jobConsoleParams.DOMAIN_TYPE">
              @for (d of domainTypeList; track $index) {
<option [ngValue]="d">{{ d }}</option>
}
            </select>
          </div>
          <div class="col-md-6">
            <label>Job Name:</label>
            <input type="text" class="form-control" name="JOB_NAME"
                   [(ngModel)]="jobConsoleParams.JOB_NAME" disabled />
          </div>
        </div>

        <!-- Row 3: Description + Is Enable -->
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Description:</label>
            <input type="text" class="form-control" name="DESCRIPTION"
                   [(ngModel)]="jobConsoleParams.DESCRIPTION" />
          </div>
          <div class="col-md-6">
            <label>Is Enable:</label>
            <select class="form-control" name="IS_ENABLE"
                    [(ngModel)]="jobConsoleParams.IS_ENABLE">
              @for (e of isEnableList; track $index) {
<option [ngValue]="e">{{ e }}</option>
}
            </select>
          </div>
        </div>

        <!-- Row 4: Schedule + Proc Call (both disabled) -->
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Schedule:</label>
            <input type="text" class="form-control" name="SCHEDULE"
                   [(ngModel)]="jobConsoleParams.SCHEDULE" disabled />
          </div>
          <div class="col-md-6">
            <label>Proc Call:</label>
            <input type="text" class="form-control" name="PROC_CALL"
                   [(ngModel)]="jobConsoleParams.PROC_CALL" disabled />
          </div>
        </div>

        <!-- Row 5: Default Input + Update/Cancel actions -->
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Default Input:</label>
            <input type="text" class="form-control" name="DEFAULT_INPUT"
                   [(ngModel)]="jobConsoleParams.DEFAULT_INPUT" />
          </div>
          <div class="col-md-6 inline-actions">
            <button class="btn btn-warning btn-sm" type="button"
                    [disabled]="crudLoading" (click)="update()">
              @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
              Update
            </button>
            <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">
              Cancel
            </button>
          </div>
        </div>

        <!-- Row 6: Job Parameters + Execute action (highlighted block) -->
        <div class="row row-spaced execute-block">
          <div class="col-md-6">
            <label>Job Parameters:</label>
            <input type="text" class="form-control" name="JOB_PARAMS"
                   [(ngModel)]="jobConsoleParams.JOB_PARAMS" />
          </div>
          <div class="col-md-6 inline-actions">
            <button class="btn btn-info btn-sm" type="button"
                    [disabled]="isExecuting" (click)="execute()">
              @if (isExecuting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
              Execute
            </button>
          </div>
        </div>

      
}

    </form>
  </div>
</div>
